import cacheAngularTemplate from 'cacheAngularTemplate';
import trashcanSlateGrey from 'vectors/trashcan_slate_grey.svg';
import template from '../views/edit_english_documents.html';
import angularModule from './settings_module';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('editEnglishDocuments', [
    '$injector',

    function factory($injector) {
        const User = $injector.get('User');
        const TranslationHelper = $injector.get('TranslationHelper');
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const DialogModal = $injector.get('DialogModal');
        const PrivateUserDocumentsHelper = $injector.get('PrivateUserDocumentsHelper');
        const S3EnglishLanguageProficiencyDocument = $injector.get('S3EnglishLanguageProficiencyDocument');
        const frontRoyalUpload = $injector.get('frontRoyalUpload');

        return {
            restrict: 'E',
            templateUrl,
            scope: {
                user: '<',
                userProxy: '<',
                adminMode: '=?',
                cannotUploadOnThisDevice: '=?',
            },
            link(scope) {
                scope.trashcanSlateGrey = trashcanSlateGrey;

                NavigationHelperMixin.onLink(scope);

                scope.downloadDocument = document => PrivateUserDocumentsHelper.downloadDocument(document);
                scope.viewDocument = document => PrivateUserDocumentsHelper.viewDocument(document);

                const editDocumentsTranslationHelper = new TranslationHelper('settings.edit_documents'); // pain to refactor

                scope.englishLanguageProficiencyDocumentsUploadIsDisabled = () =>
                    scope.uploadingEnglishLanguageProficiencyDocument ||
                    (!scope.adminMode &&
                        (scope.userProxy.s3_english_language_proficiency_documents.length >=
                            User.maxEnglishLanguageProficiencyDocuments ||
                            !scope.userProxy.recordsIndicateUserShouldUploadEnglishLanguageProficiencyDocuments));

                Object.defineProperty(scope, 'documentCommentsAreaIsDisabled', {
                    get() {
                        if (scope.adminMode) {
                            return false;
                        }

                        if (!scope.userProxy.recordsIndicateUserShouldUploadEnglishLanguageProficiencyDocuments) {
                            return true;
                        }

                        return scope.userProxy.english_language_proficiency_documents_approved;
                    },
                    configurable: true,
                });

                scope.englishLanguageProficiencyDocumentsTypeOptions = $injector
                    .get('ENGLISH_LANGUAGE_PROFICIENCY_DOCUMENTS_TYPES')
                    .map(type => ({
                        value: type,
                        label: editDocumentsTranslationHelper.get(type),
                    }));

                scope.onEnglishLanguageProficiencyDocumentSelect = ($file, $errFiles) => {
                    scope.englishLanguageProficiencyDocumentErrMessage = null;
                    scope.uploadingEnglishLanguageProficiencyDocument = true;

                    // Include document-related user attributes in the upload request so they
                    // are saved atomically with the document on the backend. This prevents a
                    // race condition where navigating away before the response resolves would
                    // leave english_language_proficiency_documents_type unset on the user.
                    // We filter out null/undefined values because multipart form data serializes
                    // them as the string "null"/"undefined".
                    const userAttrs = Object.fromEntries(
                        Object.entries({
                            english_language_proficiency_documents_type:
                                scope.userProxy.english_language_proficiency_documents_type,
                            english_language_proficiency_documents_approved:
                                scope.userProxy.english_language_proficiency_documents_approved,
                            english_language_proficiency_comments:
                                scope.userProxy.english_language_proficiency_comments,
                            transcripts_verified: scope.userProxy.transcripts_verified,
                        }).filter(([, value]) => value != null),
                    );

                    frontRoyalUpload
                        .handleNgfSelect($file, $errFiles, file => ({
                            url: S3EnglishLanguageProficiencyDocument.UPLOAD_URL,
                            data: {
                                record: {
                                    file,
                                    user_id: scope.userProxy.id,
                                },
                                ...userAttrs,
                            },
                            supportedFormatsForErrorMessage: '.pdf, .doc, .docx, .jpg, .png',
                        }))
                        .then(response => {
                            const englishDocumentJson =
                                response.data.contents.s3_english_language_proficiency_documents[0];

                            // Since this change happens independently of a save button, reflect
                            // it on the original object now.
                            scope.user.s3_english_language_proficiency_documents.push(
                                S3EnglishLanguageProficiencyDocument.new(englishDocumentJson),
                            );
                            scope.userProxy.s3_english_language_proficiency_documents.push(
                                S3EnglishLanguageProficiencyDocument.new(englishDocumentJson),
                            );
                        })
                        .catch(err => {
                            scope.englishLanguageProficiencyDocumentErrMessage = err && err.message;
                        })
                        .finally(() => {
                            scope.uploadingEnglishLanguageProficiencyDocument = false;
                        });
                };

                scope.deleteEnglishLanguageProficiencyDocument = index => {
                    // documents can only be deleted in adminMode
                    if (!scope.adminMode) {
                        return;
                    }

                    const fileName = scope.userProxy.s3_english_language_proficiency_documents[index].file_file_name;

                    DialogModal.confirm({
                        text: `Are you sure you want to delete transcript '${fileName}'?`,
                        confirmCallback: () => {
                            scope.deletingEnglishLanguageProficiencyDocument = true;
                            scope.userProxy.s3_english_language_proficiency_documents[index]
                                .destroy()
                                .then(
                                    () => {
                                        // Since this change happens independently of a save button, reflect
                                        // it on the original object now.
                                        scope.user.s3_english_language_proficiency_documents.splice(index, 1);
                                        scope.userProxy.s3_english_language_proficiency_documents.splice(index, 1);
                                    },
                                    err => {
                                        throw new Error(err);
                                    },
                                )
                                .finally(() => {
                                    scope.deletingEnglishLanguageProficiencyDocument = false;
                                });
                        },
                    });
                };
            },
        };
    },
]);
